export const getNotificationMessage = (notification) => {
    if (notification.type === 'orderTenderDirectMessage') {
        return `Sie haben eine neue Nachricht zum Auftrag: ${notification?.details?.title}`;
    } else if (notification.type === 'orderDirectMessage') {
        return `Sie haben eine neue Nachricht zum Auftrag: ${notification?.details?.title}`;
    } else if (notification.type === 'progressUpdateTender') {
        return `Der Status zum Auftrag: ${notification?.details?.title} hat sich geändert`;
    } else if (notification.type === 'progressUpdate') {
        return `Der Status zum Auftrag: ${notification?.details?.title} hat sich geändert`;
    } else if (notification.type === 'progressUpdateStageBack') {
        return `Der Status zum Auftrag: ${notification?.details?.title} hat sich geändert`;
    } else if (notification.type === 'progressUpdateStuck') {
        return `Der Auftrag: ${notification?.details?.title} ist seit 30 Tagen inaktiv`;
    } else if (notification.type === 'progressUpdateCompleted') {
        return `Der Auftrag: ${notification?.details?.title} ist abgeschlossen`;
    } else if (notification.type === 'tenderMessage') {
        return `Sie haben eine neue Nachricht zur Ausschreibung: ${notification?.details?.title}`;
    }  else if (notification.type === 'tenderNewBid') {
        return `Ein neues Angebot zur Ausschreibung: ${notification?.details?.title} liegt für Sie vor`;
    } else {
        return `Sie haben eine neue Nachricht`;
    }
};